import { OnInit } from '@angular/core';
var CounselorsComponent = /** @class */ (function () {
    function CounselorsComponent() {
    }
    CounselorsComponent.prototype.ngOnInit = function () {
    };
    return CounselorsComponent;
}());
export { CounselorsComponent };
